/* eslint-disable no-undef */
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { store } from 'stores/index';
import App from './App';
import { i18nReady } from './libraries/i18n';

// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn: process.env.REACT_APP_SENRTY_DSN,
//     integrations: [
//       new Sentry.BrowserTracing({
//         // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//         tracePropagationTargets: [process.env.PUBLIC_URL]
//       }),
//       new Sentry.Replay()
//     ],
//     // Performance Monitoring
//     tracesSampleRate: 0.3, // Capture 100% of the transactions
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 0.2 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   });
// }

const root = ReactDOM.createRoot(document.getElementById('root'));

// Diller artik ayri chunk olarak yukleniyor (bkz. libraries/i18n.js), yani
// ceviriler ilk render'da hazir degil. Bunu beklemeden render edersek ekranda
// bir an ham ceviri anahtarlari gorunur.
const render = () =>
  root.render(
    // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
    // </React.StrictMode>
  );

i18nReady.finally(render);
